import Header from "../components/Header";
import ListCardEvents from "../components/ListCardEvents";

export default function Home() {

    return <>
        <Header titulo="Eventos Hyper"/>
        <ListCardEvents />
    </>
}
